const baseUrl = "https://firstimpactscholarships.idfcfirstbank.com/scholarship";

//const baseUrl = "https://firstimpactscholarships-uat.idfcfirstbank.com/scholarship";
// const baseUrl = "https://firstimpactscholarships-dev.idfcfirstbank.com/scholarship";

//const baseUrl = "http://localhost:7070";
export const api = {
  // async getUser(id) {
  //   const response = await fetch(`https://jsonplaceholder.typicode.com/users/${id}`);
  //   return response.json();
  // },

  // const createUser = axios.create({
  //   baseURL,
  //   headers: {  'Cache-Control': 'no-cache',
  // Pragma: "no-cache",
  // Expires: "0",
  //     'Content-Type': 'application/json',
  //   },
  // });

  async createUser(data) {
    const response = await fetch(`${baseUrl}/api/auth/register`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async getToken(data) {
    const response = await fetch(`${baseUrl}/api/auth/refreshToken`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async getSpoc(token, id) {
    const response = await fetch(
      `${baseUrl}/api/college/bankDetails/application/${id}`,
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: data
      }
    );
    return response.json();
  },
  async getFilteredMentors(token, data) {
    const response = await fetch(`${baseUrl}/api/mentor`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async getMyMentors(token, id) {
    const response = await fetch(`${baseUrl}/api/mentor/request/${id}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: data
    });
    return response.json();
  },
  async acceptAlumni(token, data) {
    const response = await fetch(`${baseUrl}/api/connect/status`, {
      method: "PUT",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async getRequests(token, type, id) {
    const response = await fetch(
      `${baseUrl}/api/connect/alumni/${type}/received/${id}`,
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body:JSON.stringify(data)
      }
    );
    return response.json();
  },
  async getNotifications(token, id) {
    const response = await fetch(
      `${baseUrl}/api/notification/application/${id}`,
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: data
      }
    );
    return response.json();
  },
  async updateNotifications(token, data, id) {
    const response = await fetch(
      `${baseUrl}/api/notification/application/${id}`,
      {
        method: "PUT",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  },

  async getMyAlumnis(token, type, id) {
    const response = await fetch(
      `${baseUrl}/api/connect/send/alumni/${type}/${id}`,
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: data
      }
    );
    return response.json();
  },

  async sendAlumniRequest(token, data) {
    const response = await fetch(`${baseUrl}/api/connect/send`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async getAlumni(token, type, id, data) {
    const response = await fetch(
      `${baseUrl}/api/connect/students/alumni/${type}/application/${id}
`,
      {
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  },
  async getYoutube(token) {
    const response = await fetch(`${baseUrl}/api/webinar`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: data
    });
    return response.json();
  },
  async getTAC(token, id) {
    const response = await fetch(`${baseUrl}/api/tac/application/${id}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: data
    });
    return response.json();
  },
  async setTAC(token, id) {
    const response = await fetch(`${baseUrl}/api/tac/application/${id}`, {
      method: "PUT",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: data
    });
    return response.json();
  },
  async mentorRequest(token, data) {
    const response = await fetch(`${baseUrl}/api/mentor/request`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async updateRequest(token, data) {
    const response = await fetch(`${baseUrl}/api/mentor/request`, {
      method: "PUT",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async updateAlumni(token, data) {
    const response = await fetch(`${baseUrl}/api/connect/update`, {
      method: "PUT",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async getPDFData(token, id) {
    const response = await fetch(`${baseUrl}/api/document/data/${id}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,

        "Content-Type": "application/json",
      },
      // body: JSON.stringify(data),
    });
    return response.json();
  },
  async getMobileOTP(data) {
    const response = await fetch(`${baseUrl}/api/mobile/otpGenerateMobile`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async loginMobileOTP(data) {
    const response = await fetch(`${baseUrl}/api/mobile/generateMobileOtp`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async getEmailOTP(data) {
    const response = await fetch(`${baseUrl}/api/mobile/otpGenerateEmail`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: data,
    });
    return response.json();
  },

  async verifyMobileOTP(data, linkData, refNum) {
    const response = await fetch(
      `${baseUrl}/api/mobile/otpVerify/${linkData}/${refNum}`,
      {
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Content-Type": "application/json",
        },
        body: data,
      }
    );
    return response.json();
  },

  async collegeEmpanelment(data, token, id) {
    const response = await fetch(
      `${baseUrl}/api/college/bankDetails/application/${id}`,
      {
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  },
  async login(data) {
    const response = await fetch(`${baseUrl}/api/auth/login`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async logout(token, data) {
    const response = await fetch(`${baseUrl}/api/auth/logout`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async getDocuments(parent, id, token) {
    // console.log("in getDocuments", parent, id, token);
    const response = await fetch(
      `${baseUrl}/api/document/` + parent + "/" + id,
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        //body: JSON.stringify(data),
      }
    );
    return response.json();
  },

  async uploadDocument(parent, id, token, formData) {
    const response = await fetch(
      `${baseUrl}/api/document/` + parent + "/" + id,
      {
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
    return response.json();
  },
  async deleteDocument(parent, id, token, formData) {
    const response = await fetch(`${baseUrl}/api/document`, {
      method: "DELETE",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });
    return response.json();
  },

  async impactAssessment(formData, token) {
    const response = await fetch(`${baseUrl}/api/impact`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return response.json();
  },

  async showImpact(id, token) {
    const response = await fetch(`${baseUrl}/api/impact/${id}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
      },
      // body: formData,
    });
    return response.json();
  },

  async checkFeedback(id, token) {
    const response = await fetch(`${baseUrl}/api/feedback/application/${id}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
      },
      // body: formData,
    });
    return response.json();
  },

  async raiseQuery(data, token) {
    const response = await fetch(`${baseUrl}/api/case/create`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data }),
    });
    return response.json();
  },
  async getQuery(token, id) {
    const response = await fetch(`${baseUrl}/api/case/application/${id}`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({...data}),
    });
    return response.json();
  },

  async postCommentOnQuery(data, token, id) {
    const response = await fetch(`${baseUrl}/api/case/${id}/query`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data }),
    });
    return response.json();
  },
  async dropout(data, token) {
    const response = await fetch(`${baseUrl}/api/auth/dropout`, {
      method: "PUT",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async update(data, token) {
    const response = await fetch(
      `${baseUrl}/api/auth/updateApplication?finalSubmit=false`,
      {
        method: "PUT",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  },
  async updateSalesforce(data, token) {
    const response = await fetch(
      `${baseUrl}/api/auth/updateApplication?finalSubmit=true`,
      {
        method: "PUT",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  },
  async feedback(data, token) {
    const response = await fetch(`${baseUrl}/api/feedback`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async program() {
    const response = await fetch(`${baseUrl}/api/portal`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(data),
    });
    return response.json();
  },

  async verifyPan(data, token) {
    const response = await fetch(`${baseUrl}/api/pan/verify`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  async invokeAdhaarOtp(data) {
    //return {data:{metadata:{code:'200'},resource_data:[{otpTxn:'dsafdsf'}]}};

    const response = await fetch(`${baseUrl}/api/aadhaar/otpGenerate`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
  async verifyAdhaarOtp(data) {
    //return {statusCode:200,data:{}};

    const response = await fetch(`${baseUrl}/api/aadhaar/otpVerify`, {
      method: "POST",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },
};
